import { useState } from "react";
import tooths11 from "../../assets/img/tooths/BB_11.png";
import tooths12 from "../../assets/img/tooths/BB_12.png";
import tooths13 from "../../assets/img/tooths/BB_13.png";
import tooths14 from "../../assets/img/tooths/BB_14.png";
import tooths15 from "../../assets/img/tooths/BB_15.png";
import tooths16 from "../../assets/img/tooths/BB_16.png";
import tooths17 from "../../assets/img/tooths/BB_17.png";
import tooths18 from "../../assets/img/tooths/BB_18.png";

const dentalList = [
	{ image: tooths11, dental: 11 },
	{ image: tooths12, dental: 12 },
	{ image: tooths13, dental: 13 },
	{ image: tooths14, dental: 14 },
	{ image: tooths15, dental: 15 },
	{ image: tooths16, dental: 16 },
	{ image: tooths17, dental: 17 },
	{ image: tooths18, dental: 18 },
];

export default function DentalChartUr({ chart, handleSetDentalList, handleRemoveDentalList, list }) {

	// const [list, setList] = useState([]);

	const findDental = (dentalNumber) => {
		let flag = false;
		if (!chart) return false;
		chart.map((item) => {
			if (dentalNumber == item.d_num) {
				flag = true;
			}
		});
		return flag;
	};

	const handleSelectShowNot = (e, checkFlag, id) => {
		// select tooth
		if (!list.find((e) => e === id)) {
			// setList([...list, id]);
			handleSetDentalList(id);
		} 
		else { // remove tooth
			// setList(list.filter((item) => item !== id));
			handleRemoveDentalList(id)
		} 

		// show notfication
		if (checkFlag) {
			const el = e.target.parentElement.lastChild;
			[...document.querySelectorAll(".dental-chart__charts_images__notif")].map(
				(item) => {
					item.classList.remove("show");
				},
			);
			el.classList.add("show");
			window.onclick = (e) => handleHideNot(e, el);
		}
	};

	// hide notification
	const handleHideNot = (e, el) => {
		if (!e.target.closest(".dental-chart__charts_images__item")) {
			// console.log(e.target);
			el.classList.remove("show");
		}
	};

	return (
		<div className="dental-chart__charts_images dental-chart__charts_ur">
			{dentalList.map((item) => {
				let checkFlag = findDental(item.dental);
				return (
					<div
						key={item.dental}
						className={`dental-chart__charts_images__item  ${
							list.find((e) => e === item.dental) ? "green-filter" : ""
						}`}
						onClick={(e) => handleSelectShowNot(e, checkFlag, item.dental)}
					>
						<img src={item.image} className={checkFlag ? "red-filter" : ""} />
						{checkFlag ? (
							<div className="dental-chart__charts_images__notif">
								{chart
									.filter((item2) => item2.d_num == item.dental)
									.map((item3) => (
										<div>
											<p>
												<span>({item3.id_dental_chart})</span>
											</p>
											{"-"}
											<p>
												<span>{item3.sdate}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_technician}</span>{" "}
												<span>({item3.cp_technician})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_expert}</span>{" "}
												<span>({item3.cp_expert})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.ns}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.nc}</span> <span>{item3.ncs}</span>
											</p>
										</div>
									))}
							</div>
						) : (
							<></>
						)}
					</div>
				);
			})}
		</div>
	);
}
